<mat-nav-list id="hole-schemas-list">
  <mat-list-item
    *ngFor="let item of schemas"
    (click)="selectSchema(item)"
    data-testid="fastenerSet"
    [ngClass]="{ 'last-selected': lastSelectedId === item.id }">
    <div matLine>{{ item.name }}</div>
  </mat-list-item>
</mat-nav-list>
